import React from 'react';
import { generatePath } from 'react-router-dom';
import ContributionEnumIcon from '@/components/common/contribution/ContributionEnumIcon';
import RouterLink from '@/components/common/RouterLink';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import translate from '@/lib/intl/translate';
import getEntitySource from '../lib/getEntitySource';
import DonationAmount from './DonationAmount';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
export default function GrantDonationSummary({ entity }: any) {
  const {
    amount,
    constituents: [{ constituentId, displayName }],
    donationId,
    donationTypeEnum,
  } = entity;

  return translate('CONTRIBUTION_ENTITY_SUMMARY_GRANT', {
    amount: <DonationAmount {...{ amount, donationId }} />,
    constituentLink: (
      <RouterLink to={generatePath(AuthRoutes.CONSTITUENT, { constituentId })}>
        {displayName}
      </RouterLink>
    ),
    donationType: (
      <span className="lowercase">
        <ContributionEnumIcon
          type={ContributionEnumIcon.donationType}
          enumValue={donationTypeEnum}
        />
      </span>
    ),
    ...getEntitySource(entity),
  });
}
